module.exports = __webpack_public_path__ + "ca2a9718f4ecc1cd16935b7b316bf223.MP3";